import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Container from '../../component/Container';

import styles from './index.scss';
import Skeleton from '../skeleton';

class TabsBar extends Component {
    constructor(props) {
        super(props);
        this.btn_products = React.createRef();
        this.btn_fnb = React.createRef();
        this.btn_support = React.createRef();
        this.state = {
            checked: this.btn_products,
        };
    }

    componentDidMount() {
        this.addSelection(this.state.checked);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isFnbVisible !== prevProps.isFnbVisible) {
            this.removeSelection(this.state.checked);
            const newChecked = this.props.isFnbVisible ? this.btn_fnb : this.btn_products;
            this.addSelection(newChecked);
            this.setState({
                checked: newChecked,
            });
        }
    }

    checkTab = (e, ref) => {
        this.props.scroll(ref.current.getAttribute('data-location'));
        if (ref !== this.state.checked) {
            this.setState({
                checked: ref,
            });
        }
    };

    addSelection = ref => {
        ref.current.classList.add(styles.checked);
    };

    removeSelection = ref => {
        ref.current.classList.remove(styles.checked);
    };

    render() {
        const tabClasses = classNames({
            [styles.elements]: true,
            'tab-analytics': true,
        });
        return (
            <div className={styles.container}>
                <Container>
                    <nav>
                        <ul className={styles.wrapper}>
                            <li
                                ref={this.btn_products}
                                className={tabClasses}
                                onClick={e => this.checkTab(e, this.btn_products)}
                                data-location="srp"
                                data-tab-name="products"
                            >
                                {this.props.tabs.productTabTitle}
                            </li>

                            {this.props.fnb && (
                                <li
                                    ref={this.btn_fnb}
                                    className={tabClasses}
                                    onClick={e => this.checkTab(e, this.btn_fnb)}
                                    data-location="fnb"
                                    data-tab-name="features-and-benefits"
                                >
                                    {this.props.tabs.featuresBenefitTitle}
                                </li>
                            )}
                            {this.props.supportSkeleton && (
                                <li
                                    ref={this.btn_support}
                                    className={tabClasses}
                                    data-location="support"
                                    data-tab-name="support"
                                >
                                    <Skeleton
                                        withTemplate={true}
                                        styleForTemplate={{
                                            width: '130px',
                                            height: '20px',
                                            marginBottom: '-4px',
                                        }}
                                    />
                                </li>
                            )}
                            {this.props.support && (
                                <li
                                    ref={this.btn_support}
                                    className={tabClasses}
                                    onClick={e => this.checkTab(e, this.btn_support)}
                                    data-location="support"
                                    data-tab-name="support-and-services"
                                >
                                    {this.props.tabs.categoryTabSupportServicesTitle}
                                </li>
                            )}
                        </ul>
                    </nav>
                </Container>
            </div>
        );
    }
}

TabsBar.propTypes = {
    tabs: PropTypes.object.isRequired,
    fnb: PropTypes.bool.isRequired,
    support: PropTypes.bool.isRequired,
    scroll: PropTypes.func.isRequired,
    isFnbVisible: PropTypes.bool.isRequired,
    supportSkeleton: PropTypes.bool,
};

export default TabsBar;
